export enum MarketplacePage {
  Dashboard = "dashboard",
  WorkOpportunities = "workOpportunities"
}
